import Widgets from './Settings/Widgets/Widgets'
import WidgetLists from './Settings/Widgets/WidgetLists'

export default {
    namespaced: true,
    modules: {
        Widgets: Widgets,
        WidgetLists: WidgetLists
    }
}